<template>
  <div
    class="time-range-picker el-input__wrapper el-date-editor el-date-editor--timerange"
    :class="['el-range-editor--' + size, disabled ? 'is-disabled' : '']"
    @mouseleave="showClose = false"
    @mouseenter="showClose = true"
    id="month-select"
  >
    <el-icon class="el-icon el-input__icon el-range__icon"><Clock /></el-icon>
    <el-select
      v-model="vl[0]"
      ref="startMonth"
      @change="handleValue"
      :disabled="disabled"
      :placeholder="startPlaceholder"
      :size="size"
      :validate-event="false"
    >
      <el-option
        v-for="(item, index) in month"
        :disabled="vl[1] !== '' && vl[1] < index"
        :key="item"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <slot name="range-separator">
      <span class="el-range-separator">{{ rangeSeparator }}</span>
    </slot>
    <el-select
      v-model="vl[1]"
      ref="endMonth"
      @change="handleValue"
      :disabled="disabled"
      :placeholder="endPlaceholder"
      :size="size"
      :validate-event="false"
    >
      <el-option
        v-for="(item, index) in month"
        :disabled="vl[0] !== '' && vl[0] > index"
        :key="item"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-icon
      class="el-icon el-input__icon el-range__close-icon"
      :class="[showClearable ? '' : 'el-range__close-icon--hidden']"
      @click="handleClickIcon"
    >
      <CircleClose />
    </el-icon>
  </div>
</template>
<script setup lang="ts">
import { Clock, CircleClose } from '@element-plus/icons-vue'

const props = defineProps({
  modelValue: {
    type: Array
  },
  disabled: {
    type: Boolean
  },
  rangeSeparator: {
    type: String
  },
  startPlaceholder: {
    type: String,
    default: ''
  },
  endPlaceholder: {
    type: String,
    default: ''
  },
  size: {
    type: String
  },
  clearable: {
    type: Boolean,
    default: true
  }
})

let vl = ref(['', ''])
let showClose = ref(false)
let pickerDisabled = ref(false)
let month = [
  '一月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月'
]
let startMonth = ref()
let endMonth = ref()

// 判断是否可以显示清空按钮
const showClearable = computed(
  () =>
    showClose.value &&
    props.clearable &&
    (vl.value[0] != '' || vl.value[1] != '') &&
    !props.disabled
)

// 监听外部值改变
watch(
  () => props.modelValue,
  (n) => {
    n?.forEach((item, index) => {
      let month = +item
      if (month > 0 && month < 13) {
        vl.value[index] = month - 1
      } else {
        vl.value[index] = ''
      }
    })
    // this.$forceUpdate()
  },
  {
    immediate: true,
    deep: true
  }
)

const emits = defineEmits(['update:modelValue'])

function handleClickIcon() {
  vl.value = ['', '']
  handleValue()
}

function handleValue() {
  if (vl.value[0] === '' && vl.value[1] === '') {
    emits('update:modelValue', ['', ''])
  } else if (vl.value[1] === '') {
    endMonth.value.toggleMenu()
  } else if (vl.value[0] === '') {
    startMonth.value.toggleMenu()
  } else {
    emits('update:modelValue', [s0(vl.value[0] + 1), s0(vl.value[1] + 1)])
  }
}

function s0(val) {
  return val < 10 ? '' + val : '' + val
}
</script>
<style lang="scss">
#month-select {
  .el-select {
    .el-input__wrapper {
      box-shadow: none !important;
    }
  }
}
</style>
